import component from "./ProfileFinishAttention.vue"

import wrapVueComponent from "@/utils/wrapVueComponent"
const componentName = "StudentProfileFinishAttention"

export default wrapVueComponent(componentName, component)
